export * from '../../original/js/components/selector';

// soon to be depricated.
import { Selector } from '../../original/js/components/selector';

export default Selector
